<router-outlet></router-outlet>
<lib-global-spinner></lib-global-spinner>

<!--
   mat-icon can show text in components if they aren't loaded.
   Dirty solution here to force a pre-load by loading a single one.
   (Another solution would be to self-host the Material Icons font
   instead of getting it from CDN link.)
-->
<div class="icon-preload">
    <mat-icon>close</mat-icon>
</div>
